import React, { useState, FormEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { User } from "../types/auth";

import styles from './styles/LoginPage.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface LoginResponse {
  token: string;
  refresh_token: string;
  user: User;
}

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the redirect path from location state or default to "/home"
  const from = location.state?.from?.pathname || "/home";

  const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        setErrorMessage(error.error || "Login failed.");
        return;
      }

      const data: LoginResponse = await response.json();
      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refresh_token);
      localStorage.setItem("userID", data.user.user_id.toString());

      // Redirect to the page the user was trying to access
      navigate(from);
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src="/img/buildyou_logo@3x.png" alt="BuildYou" height="50" />
      </div>
      {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
      <form onSubmit={handleLogin} className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Username:</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoCapitalize="off"
            autoFocus
            className={styles.input}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <button type="submit" className={styles.submitButton}>Login</button>
      </form>
      <div className={styles.registerContainer}>
        <span>
          Have an invite code?
          <a href="/register" className={styles.registerLink}>Register</a>
        </span>
      </div>
    </div>
  );
};

export default LoginPage; 